import { StatusLabelEnum } from "src/app/components/status-label/status-label.component";
import { Platform } from "src/app/models/api/common";
import { ResourceStatus } from "src/app/models/api/inventoryResource.model";
import { ViolationResource, ViolationStatusReason } from "src/app/models/api/violations.model";

export class InventoryHelper {
    public static getResourceStatusLabel(resourceStatus?: ResourceStatus): StatusLabelEnum {
        if (resourceStatus === ResourceStatus.inactive) {
            return StatusLabelEnum.inactive;
        } else if (resourceStatus == ResourceStatus.pendingDeletion) {
            return StatusLabelEnum.pendingDeletion;
        }

        return StatusLabelEnum.active;
    }

    public static getViolationRelatedResourceStatusLabel(
        violationResource: ViolationResource,
        violationStatusReason: ViolationStatusReason,
    ): StatusLabelEnum {
        if (violationStatusReason === ViolationStatusReason.resourceDeleted) {
            return StatusLabelEnum.deleted;
        }

        const platform = violationResource.platformInfo.platform;

        if (platform !== Platform.powerplatform && platform !== Platform.workato) {
            return StatusLabelEnum.active;
        }

        return this.getResourceStatusLabel(violationResource.resourceState?.status);
    }
}
